<template>
  <div class="company-content-wrapper">
    <div class="l-bg-white">
      <div v-if="step === 'companies-info'">
        <companies-info v-if="company" :company="company" type="setup" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';
import CompaniesInfo from './CompaniesInfo';

export default {
  components: {
    CompaniesInfo,
  },
  data: () => ({
    company: null,
  }),
  computed: {
    ...mapState({
      step: state => state.companies.step,
      user: state => state.auth.dispatchUser,
    }),
  },
  mounted() {
    this.$store.dispatch('getAuthFromStorage').then(() => this.$emit('saved'));
    if (this.user.companies.length === 1) {
      axios.get(`companies/${this.user.companies[0].id}`).then(res => {
        res.data.data.zip = res.data.data.zip ? res.data.data.zip.zip : '';
        this.company = res.data.data;
        this.setCompany(this.company);
      });
    }
  },
  destroyed() {
    this.setCompanyStep('companies-info');
  },
  methods: {
    ...mapMutations(['setCompany', 'setCompanyStep']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/companies/CompaniesSetup.vue